<div class="container-fluid h-100 readOnlyForm pl-0 pr-0">

  <!-- Section header start -->
  <div class="headerBackground card p-1 mb-2 tool-header-height">
    <div class="row padding2px">
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 sectionHeaderIcon">
        <span>
          <fa-icon class="fas fa-lg autoCursor" title="click for smart checklist" (click)="openSmartChecklist()"
            [icon]="faBug"></fa-icon>
        </span>
      </div>
      <div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-4">
        <h6 class="headerFontSize cursorArrow">{{ 'menu.bugsmapper' | translate }}</h6>
      </div>
      <div class="col col-7 col-md-7 col-lg-7 col-sm-7 col-xs-6 cursorArrow">
        <p class="titleParagraph">{{'jiraBugsMapper.toolHeaderLine1' | translate}}<br>
          {{'jiraBugsMapper.toolHeaderLine2' | translate}}
        </p>
      </div>
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1">
        <table class="dropGroupBtn">
          <tr>
            <td rowspan="2">
              <span>
                <a id="environmentYoutube" type="button" class="" data-toggle="modal" data-target="#ytVideoLinkTP1">
                  <fa-icon class="fas fa-lg" [icon]="faInfoCircle" title="help"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <!-- <span >
                <fa-icon class="fas fa-lg" [icon]="faFileExport" title="report"></fa-icon>
              </span> -->
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
  <!-- Section header end -->
  <!-- <div class="row mt-0 mb-0" style="padding: 0%;">
    <div class="col-xs-7"></div>
    <div class="col-xs-3">
      <div class="dropdown">
        <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px" type="button"
          data-toggle="dropdown">
          <div class="row strict">
            <div class="col-xs-11 span-on-button" style="left: 0px;">
              {{selectedlevel}}
            </div>
            <div class="col-xs-1 pull-right ">
              <span class="caret"></span>
            </div>
          </div>
        </button>
        <ul class="dropdown-menu">
          <li *ngFor="let le of levels" (click)="chooseLevel(le)" >
            <a>{{le}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-xs-2">
      <button type="button" (click)="saveSelectedBugs()" class="btn btn-default btn-block btn-sm tpButton">
        Save
      </button>
    </div>
  </div> -->

  <div class="environ-designer tool-body-height">

    <div class="card p-1 mb-2 bg-white h-100">
      <div class="row full-width p-0">
        <div class="col-xs-9 btn-padding pl-0 pr-2">
          <div *ngIf="showText == false" class="dropdown">
            <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
              type="button" data-toggle="dropdown">
              <div class="row strict">
                <div class="col-xs-10 span-on-button ">
                  <span *ngIf="projectDefectSets.length>0"><span
                      *ngIf="selectedDefectSet">{{selectedDefectSet.name}}</span>
                    <span *ngIf="!selectedDefectSet">Choose defect set</span>
                  </span>
                </div>
                <div class="col-xs-1 col-xs-offset-1 pull-right ">
                  <span class="caret"></span>
                </div>
              </div>
            </button>
            <ul class="dropdown-menu" *ngIf="projectDefectSets.length > 0">
              <li *ngFor="let set of projectDefectSets" (click)="chooseDefectSet(set)">
                <a>{{set.name}}</a>
              </li>
            </ul>
          </div>
          <div *ngIf="showText == true">
            <input type="text" (keyup.enter)="savedefectSet()"
              [placeholder]="'jiraBugsMapper.enteradefectset'|translate" [(ngModel)]="defectSetname"
              id="adddefectSetname" class="form-control strict lg-input pl-3 pr-3 suites-inputfield">
          </div>
        </div>
        <div class="col-xs-2 btn-padding pr-0">
          <div class="row strict">
            <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1">
              <div>
                <button type="button" (click)="AddchooseDefectSet(true,true,{})"
                  class="btn btn-default btn-block btn-sm labelReadOnly paddingtop3px paddingbottom3px">
                  <fa-icon class="fas icon-black" [icon]="faPlus"></fa-icon>
                </button>
              </div>
            </div>
            <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1">
              <div>
                <button type="button" (click)="editDefectSet(selectedDefectSet.name)"
                  class="btn btn-block btn-default btn-sm labelReadOnly paddingtop3px paddingbottom3px">
                  <fa-icon class="fas icon-black" [icon]="faEdit"></fa-icon>
                </button>
              </div>
            </div>
            <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1">
              <div *ngIf="showText == false">
                <button type="button" data-toggle="modal" data-target="#suiteDeleteConfirmModel"
                  class="btn btn-default btn-block btn-sm labelReadOnly paddingtop3px paddingbottom3px">
                  <fa-icon class="fas icon-black" [icon]="faTrash"></fa-icon>
                </button>
              </div>
              <div *ngIf="showText == true">
                <button type="button" (click)="clear()"
                  class="btn btn-default btn-block btn-sm labelReadOnly paddingtop3px paddingbottom3px">
                  <fa-icon class="fas icon-black" [icon]="faTimes"></fa-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row strict">
        <ul class="nav nav-tabs">
          <li class="active">
            <a data-toggle="tab" id="designerActiveTab" class="textClrWhite" (click)="changeTab('import');resetImport()"
              ng-attr-data-target="#specsTab">{{'jiraBugsMapper.import' | translate }}</a>
          </li>
          <li (click)="changeTab('levelize')">
            <a data-toggle="tab" class="textClrWhite" ng-attr-data-target="#notesTab">{{'jiraBugsMapper.levelize' |
              translate }}</a>
          </li>
          <li (click)="changeTab('analyze');chooseDefectSet(selectedDefectSet)">
            <a data-toggle="tab" class="textClrWhite" ng-attr-data-target="#mapsTab">{{'jiraBugsMapper.analyze' |
              translate }}</a>
          </li>
        </ul>
      </div>
      <div class="tab-content test-designer-nav-tab-content-height card">
        <div ng-attr-id="notesTab" *ngIf="currentTab == 'import'" class="tab-pane fade active in h-100">
          <div class="col-xs-3 col-md-3 table-bordered card textClrWhite h-100">
            <div class="row">
              <div class="dropdown">
                <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                  type="button" data-toggle="dropdown">
                  <div class="row strict">
                    <div class="col-xs-11 span-on-button" style="left: 0px;">
                      {{importType}}
                    </div>
                    <div class="col-xs-1 pull-right ">
                      <span class="caret"></span>
                    </div>
                  </div>
                </button>
                <ul class="dropdown-menu">
                  <li *ngFor="let le of importTypes" (click)="chooseImportType(le)">
                    <a>{{le}}</a>
                  </li>
                </ul>
              </div>
            </div>
            <div *ngIf="importType == 'CSV'">
              <input type="file" class="upload" (change)="changeListener($event.target.files)" accept=".csv" />
            </div>
            <div *ngIf="importType == 'Jira'">
              <div class="dropdown">
                <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                  type="button" data-toggle="dropdown">
                  <div class="row strict">
                    <div class="col-xs-11 span-on-button" style="left: 0px;">
                      {{selectedfilterName}}
                    </div>
                    <div class="col-xs-1 pull-right ">
                      <span class="caret"></span>
                    </div>
                  </div>
                </button>
                <ul class="dropdown-menu">
                  <li>
                    <div class="row">
                      <div class="col-xs-12">
                        <div class="input-group input-group-sm">
                          <input type="text" class="form-control search-add-on" [(ngModel)]="searchfilter"
                            [placeholder]="'jiraBugsMapper.searchFilter' | translate">
                          <span class="input-group-addon " id="basic-addon2">
                            <fa-icon class="fas icon-black" [icon]="faSearch"></fa-icon>
                          </span>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li *ngFor="let le of jiraFilters|jiraBugsSearchPipe:searchfilter:'filter':prioritylevelSelected"
                    (click)="chooseFilter(le)">
                    <a>{{le.name}}</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="h-90" *ngIf="importType == 'CSV' && CSVheaders.length > 0">
              <table
                class="table env1 bg-color-black mb-0 h-100 table-bordered tableBackgrdClrBlack menuItemsClrWhite tasksTable cursorArrow">
                <thead>
                  <tr class="row strict">
                    <th class="col-xs-6 border-right1px">
                      Key
                    </th>
                    <th class="col-xs-6 border-right1px">
                      Value
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="row strict">
                    <td class="col-xs-6 border-right1px">
                      BugID
                    </td>
                    <td class="col-xs-6 border-right1px">
                      <div class="dropdown">
                        <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                          type="button" data-toggle="dropdown">
                          <div class="row strict">
                            <div class="col-xs-11 span-on-button" style="left: 0px;">
                              {{headerbugID}}
                            </div>
                            <div class="col-xs-1 pull-right ">
                              <span class="caret"></span>
                            </div>
                          </div>
                        </button>
                        <ul class="dropdown-menu" style="min-width: 81px;">
                          <li *ngFor="let head of CSVheaders" (click)="chooseHeader('bugID',head)">
                            <a>{{head}}</a>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                  <tr class="row strict">
                    <td class="col-xs-6 border-right1px">
                      summary
                    </td>
                    <td class="col-xs-6 border-right1px">
                      <div class="dropdown">
                        <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                          type="button" data-toggle="dropdown">
                          <div class="row strict">
                            <div class="col-xs-11 span-on-button" style="left: 0px;">
                              {{headersummary}}
                            </div>
                            <div class="col-xs-1 pull-right ">
                              <span class="caret"></span>
                            </div>
                          </div>
                        </button>
                        <ul class="dropdown-menu" style="min-width: 81px;">
                          <li *ngFor="let head of CSVheaders" (click)="chooseHeader('summary',head)">
                            <a>{{head}}</a>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                  <tr class="row strict">
                    <td class="col-xs-6 border-right1px">
                      description
                    </td>
                    <td class="col-xs-6 border-right1px">
                      <div class="dropdown">
                        <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                          type="button" data-toggle="dropdown">
                          <div class="row strict">
                            <div class="col-xs-11 span-on-button" style="left: 0px;">
                              {{headerdescription}}
                            </div>
                            <div class="col-xs-1 pull-right ">
                              <span class="caret"></span>
                            </div>
                          </div>
                        </button>
                        <ul class="dropdown-menu" style="min-width: 81px;">
                          <li *ngFor="let head of CSVheaders" (click)="chooseHeader('desc',head)">
                            <a>{{head}}</a>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                  <tr class="row strict">
                    <td class="col-xs-6 border-right1px">
                      created on
                    </td>
                    <td class="col-xs-6 border-right1px">
                      <div class="dropdown">
                        <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                          type="button" data-toggle="dropdown">
                          <div class="row strict">
                            <div class="col-xs-11 span-on-button" style="left: 0px;">
                              {{headercreatedOn}}
                            </div>
                            <div class="col-xs-1 pull-right ">
                              <span class="caret"></span>
                            </div>
                          </div>
                        </button>
                        <ul class="dropdown-menu" style="min-width: 81px;">
                          <li *ngFor="let head of CSVheaders" (click)="chooseHeader('created',head)">
                            <a>{{head}}</a>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- <table id="taskPlannerListTable" *ngIf="CSVimportList.length > 0"
              class="table env1 bg-color-black mb-0 h-100 table-bordered tableBackgrdClrBlack menuItemsClrWhite tasksTable">
              <thead>
                <tr class="row strict">
                  <th class="col-xs-11 border-right1px">
                    <div class="row strict">
                      <div class="col col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        {{'jiraBugsMapper.description' | translate}}
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody class="task-planner-tasks-table-body-height" *ngIf="CSVimportList.length > 0">
                <tr class="clickable-row border-bottom1px" *ngFor="let bug of CSVimportList"
                  class="cursorPointer bg-color-black">
                  <td class="col-xs-11 border-right1px border-left1px">
                    <span title="{{bug.description}}"> {{ bug.summary }} </span>
                  </td>
                </tr>
              </tbody>
              <tbody class="task-planner-tasks-table-body-height" *ngIf="CSVimportList.length == 0">
                No bugs to display.
              </tbody>
            </table> -->
            </div>
            <div class="row">
              <button style="float: left !important; color: black; width: 100%;"
                (click)="generateViewdata()">View</button>
            </div>
          </div>
          <div class="col-xs-9 col-md-9 table-bordered card textClrWhite h-100">
            <table id="taskPlannerListTable"
              class="table env1 bg-color-black mb-0 h-100 table-bordered tableBackgrdClrBlack menuItemsClrWhite tasksTable cursorArrow">
              <thead>
                <tr class="row strict">
                  <th class="col-xs-11 border-right1px">
                    <!-- <div class="row strict"> -->
                    <!-- <div class="col col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"> -->
                    {{'jiraBugsMapper.description' | translate}}
                    <!-- </div> -->
                    <!-- </div> -->
                  </th>
                </tr>
              </thead>
              <tbody class="task-planner-tasks-table-body-height" *ngIf="importListBugs.length > 0">
                <tr class="clickable-row border-bottom1px" *ngFor="let bug of importListBugs"
                  class="cursorPointer bg-color-black">
                  <td class="col-xs-11 border-right1px border-left1px">
                    <span title="{{bug.description}}"> {{ bug.summary }} </span>
                  </td>
                </tr>
              </tbody>
              <tbody class="task-planner-tasks-table-body-height" *ngIf="importListBugs.length == 0">
                No bugs to display.
              </tbody>
            </table>
            <button style="float: right !important; color: black;" (click)="updateDefectSetBugs()">Import</button>
          </div>
        </div>
        <div ng-attr-id="specsTab" *ngIf="currentTab == 'levelize'" class="tab-pane fade active in h-100">
          <div class="card p-1 h-100 bg-white">
            <div class="row mt-0 mb-0" style="padding: 0%;">
              <div class="col-xs-7">
                <div class="row" style="padding: 0px;">
                  <div class="col-xs-12">
                    <div class="input-group input-group-sm">
                      <input type="text" class="form-control search-add-on" [(ngModel)]="searchText"
                        [placeholder]="'jiraBugsMapper.searchBug' | translate">
                      <span class="input-group-addon " id="basic-addon2">
                        <fa-icon class="fas icon-black" [icon]="faSearch"></fa-icon>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xs-1"></div>
              <div class="col-xs-1">
                <!-- <div class="dropdown">
                  <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                    type="button" data-toggle="dropdown">
                    <div class="row strict">
                      <div class="col-xs-11 span-on-button" style="left: 0px;">
                        {{primaryLevel}}
                      </div>
                      <div class="col-xs-1 pull-right ">
                        <span class="caret"></span>
                      </div>
                    </div>
                  </button>
                  <ul class="dropdown-menu" style="min-width: 81px;">
                    <li *ngFor="let le of levels" (click)="chooseMainLevel(le)">
                      <a>{{le}}</a>
                    </li>
                  </ul>
                </div> -->
              </div>
              <div class="col-xs-3">
              </div>
            </div>
            <div class="col-xs-12 task-planner-tasks-table-height table-bordered border-none card p-1 mb-2 bg-white">
              <table id="taskPlannerListTable"
                class="table env1 bg-color-black mb-0 h-100 table-bordered tableBackgrdClrBlack menuItemsClrWhite tasksTable">
                <thead>

                  <tr class="border-bottom1px">
                    <th class="col-xs-1 mapperReadOnly border-right1px">
                      <div style="text-align: center;">
                        <!-- <input type="checkbox" id="selectAllAdd" (click)="selectAllBugs($event.target.checked)">  -->
                        Select
                        <!-- all -->
                      </div>
                    </th>
                    <th class="col-xs-10 border-right1px">
                      {{'jiraBugsMapper.description' | translate}} ({{projectDefectSetsBugs.length}})

                    </th>

                    <!-- <th class="col-xs-1 border-right1px">
                      <div class="dropdown">
                        <button
                          class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                          type="button" data-toggle="dropdown">
                          <div class="row strict">
                            <div class="col-xs-7 span-on-button ">
                              {{'testManager.attributes' | translate}}
                            </div>
                            <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                              <span class="caret"></span>
                            </div>
                          </div>
                        </button>
                        <ul class="dropdown-menu text-color-black w-300">
                          <li class="row padding-vertical" *ngFor="let a of listOfAttributes">
                            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                              <div style="text-align: center;">
                                <input class="checkboxReadOnly" type="checkbox">
                              </div>
                            </div>
                            <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 dropdown-item">
                              {{a.name+" ("+a.symbol+")"}}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </th>
                    
                    <th class="col-xs-1 border-right1px">
                      <div class="dropdown">
                        <button
                          class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                          type="button" data-toggle="dropdown">
                          <div class="row strict">
                            <div class="col-xs-7 span-on-button ">
                              +/-
                            </div>
                            <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                              <span class="caret"></span>
                            </div>
                          </div>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-right text-color-black minwidth-100">
                          <li class="row padding-vertical">
                            <div
                              class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1 col-md-3 col-md-offset-1 col-lg-3 col-lg-offset-1 col-xl-1 col-xl-offset-1">
                              <div style="text-align: center;">
                                <input class="checkboxReadOnly" type="checkbox">
                              </div>
                            </div>
                            <div
                              class="col-xs-7 col-xs-offset-1 col-sm-7 col-sm-offset-1 col-md-7 col-md-offset-1 col-lg-7 col-lg-offset-1 col-xl-9 col-xl-offset-1 dropdown-item">
                              +
                            </div>
                          </li>
                          <li class="row padding-vertical">
                            <div
                              class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1 col-md-3 col-md-offset-1 col-lg-3 col-lg-offset-1 col-xl-1 col-xl-offset-1">
                              <div style="text-align: center;">
                                <input class="checkboxReadOnly" type="checkbox">
                              </div>
                            </div>
                            <div
                              class="col-xs-7 col-xs-offset-1 col-sm-7 col-sm-offset-1 col-md-7 col-md-offset-1 col-lg-7 col-lg-offset-1 col-xl-9 col-xl-offset-1 dropdown-item">
                              -
                            </div>
                          </li>
                        </ul>
                      </div>
                    </th> -->
                    <th class="col-xs-1 border-right1px">
                      <div class="dropdown">
                        <button
                          class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px filterDropdownBtn"
                          type="button" data-toggle="dropdown">
                          <div class="row strict">
                            <div class="col-xs-7 span-on-button ">
                              Levels
                            </div>
                            <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                              <span class="caret"></span>
                            </div>
                          </div>
                        </button>
                        <ul class="dropdown-menu text-color-black minwidth-100">
                          <li class="row padding-vertical" *ngFor="let a of config.levels">
                            <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5 col-xl-5">
                              <div style="text-align: center;">
                                <input class="checkboxReadOnly" type="checkbox"
                                  (click)="addToPriorityFilter(a,$event.target.checked)">
                              </div>
                            </div>
                            <div class="col-xs-7 col-sm-7 col-md-7 col-lg-7 col-xl-7 dropdown-item">
                              {{a}}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody class="bugs-mapper-table-body-height" *ngIf="projectDefectSetsBugs.length > 0">
                  <tr class="clickable-row border-bottom1px"
                    *ngFor="let bug of projectDefectSetsBugs|jiraBugsSearchPipe:searchText:'bug':prioritylevelSelected"
                    class="cursorPointer bg-color-black">
                    <td class="col-xs-1 border-right1px border-left1px al">
                      <input type="checkbox" class="align_center" [checked]="multipleBugsArray.indexOf(bug._id)>-1"
                        (click)="addtoMultipleBugs(bug._id,$event.target.checked)">
                    </td>
                    <td class="col-xs-10 border-right1px border-left1px">
                      <span title="{{bug.description}}"> {{ bug.summary }} </span>
                    </td>
                    <td class="col-xs-1 border-right1px ">
                      <div class="dropdown">
                        <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                          type="button" data-toggle="dropdown">
                          <div class="row strict">
                            <div class="col-xs-11 span-on-button" style="left: 0px;">
                              {{bug.level}}
                            </div>
                            <div class="col-xs-1 pull-right ">
                              <span class="caret"></span>
                            </div>
                          </div>
                        </button>
                        <ul class="dropdown-menu" style="min-width: 81px;">
                          <li *ngFor="let le of levels" (click)="chooseLevel(bug,le)">
                            <a>{{le}}</a>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody class="task-planner-tasks-table-body-height" *ngIf="projectDefectSetsBugs.length == 0">
                  No bugs to display.
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div ng-attr-id="mapsTab" *ngIf="currentTab == 'analyze'" style="background-color: white;"
          class="tab-pane fade active in h-100">
          <div class="row">
            <div class="col-xs-4 cursorArrow">
              <input type="checkbox" (click)="compareDefectSets($event.target.checked)" [checked]="comparative"> Compare
              with
              <div *ngIf="comparative == true" class="dropdown">
                <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                  type="button" data-toggle="dropdown">
                  <div class="row strict">
                    <div class="col-xs-10 span-on-button ">
                      <span *ngIf="projectDefectSets.length>0"><span
                          *ngIf="compareDefectSet">{{compareDefectSet.name}}</span>
                        <span *ngIf="!compareDefectSet">{{'jiraBugsMapper.choosedefectset' |
                          translate}}</span>
                      </span>
                    </div>
                    <div class="col-xs-1 col-xs-offset-1 pull-right ">
                      <span class="caret"></span>
                    </div>
                  </div>
                </button>
                <ul class="dropdown-menu" *ngIf="projectDefectSets.length > 0">
                  <li *ngFor="let set of projectDefectSets" (click)="chooseCompareDefectSet(set)">
                    <a *ngIf="this.selectedDefectSet._id != set._id">{{set.name}}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="row strict h-100">
            <div class="col-md-1"></div>
            <div class="col-md-4">
              <div>
                <canvas id="FuctionalEUTpie" width="500" height="500" #FuctionalEUTpie></canvas>
              </div>
            </div>

            <div class="col-md-2">
              <!-- <div style="width: 75%;">
                  <canvas id="mychartStacked" width="300" height="200" #mychartStacked></canvas>
                </div> -->
            </div>
            <div class="col-md-4">
              <div>
                <canvas id="defectSetLineChart" width="500" height="500" #defectSetLineChart></canvas>
              </div>
            </div>
            <div class="col-md-1"></div>
          </div>
        </div>
        <!-- //othertwo tabs content -->
        <!-- </div> -->
      </div>
    </div>
  </div>
  <!-- Section footer start -->
  <div class="headerBackground card p-1 mt-2 tool-footer-height">
    <div class='row pb-0 pt-0'>
      <div id="taskplannerTip1" class="carousel slide" data-ride="carousel" data-interval="false">
        <!-- Wrapper for slides -->
        <div class="carousel-inner text-color-yellow">
          <div class="row item active text-color-yellow">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #1 : {{'jiraBugsMapper.tip1' | translate}}
            </div>
          </div>
          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #2 : {{'jiraBugsMapper.tip2' | translate}}
            </div>
          </div>
          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #3 : {{'jiraBugsMapper.tip3' | translate}}
            </div>
          </div>
        </div>
        <!-- Left and right controls -->
        <a class="left carousel-control carousel-tip-align display-flex" data-target="#taskplannerTip1"
          data-slide="prev">
          <span>
            <fa-icon class="fas" [icon]="faChevronLeft"></fa-icon>
          </span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control carousel-tip-align display-flex" data-target="#taskplannerTip1"
          data-slide="next">
          <span>
            <fa-icon class="fas" [icon]="faChevronRight"></fa-icon>
          </span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
  <!-- Section footer end -->
</div>